const trimPostProcessor = (value: string) => {
  if (typeof value === "string") {
    return value.trim();
  }
  return value;
};

export const trimPlugin = {
  type: "postProcessor",
  name: "trim",
  process: trimPostProcessor,
} as const;
